export const HEY = 'أهلا';
export const SUPPORT_MESSAGE = `رجاء لا تتردد بالتواصل معنا\nتواصل معنا في أي وقت على support@fosol.com`;
export const HELP_PLACEHOLDER = 'بماذا نستطيع مساعدتك؟';
export const ASK_HELP = 'اطلب مساعدتنا';



// WEBPACK FOOTER //
// ./src/lang/ar/support.js